import { useTranslation } from 'react-i18next';

import { StatusBadge } from '../../../../components/design-system/admin';
import type { LeadTier } from '../../../../common/hooks/use-lead-desk-api.hook';
import { TIER_TONE } from '../lead-desk-view';

/** Hot, warm or cold as a dot and a word, with the score when asked — the only colour on a card. */
export function LeadTierBadge({ tier, score, className }: { tier: LeadTier; score?: number; className?: string }) {
    const { t } = useTranslation();
    return (
        <StatusBadge tone={TIER_TONE[tier]} className={className}>
            {t(`LEAD_DESK.TIER.${tier.toUpperCase()}`)}
            {typeof score === 'number' && <span className="tabular-nums text-muted-foreground">· {score}</span>}
        </StatusBadge>
    );
}
